import React from 'react';
import { Link } from 'react-router-dom';

class NotFoundPage extends React.Component {
    render() {
        return <div className="container" style={{ width: "100%", minHeight: "38.8vh" }}>
            <div className="col-sm-12 row" style={{ margin: "50px auto" }}>
                <div className="col-xs-121 margin-bottom">
                    <div className="col-sm-12 margin">
                        <h3>
                            Page Not Found
                        </h3>
                    </div>
                    <hr />
                </div>
                <div className="col-sm-12 row">
                    <p>Sorry! The page you are looking for doesn't exist.</p>
                </div>
                <br />
                <div className="col-sm-12 row">
                    <Link to="/">Go to Home </Link>
                </div>       
            </div>
        </div>;
    }
}
export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/components/Error/PageNotFound.js